import { Row, Col, Container } from 'react-bootstrap';
import Review from '../reviewx/Review';
import LayoutWithoutmenues from '../../../layouts/layoutWithoutmenues/LayoutWithoutmenues';
import './checkoutLayout.css';

function CheckoutLayout(props) {
  const { children } = props;
  return (
    <LayoutWithoutmenues>
      <section className="checkoutLayout">
        <div className="top">
          <Container>
            <Row>
              <Col md={8}>
                <Review />
              </Col>
            </Row>
          </Container>
        </div>
        {children}
      </section>
    </LayoutWithoutmenues>
  );
}

export default CheckoutLayout;
